import { ca } from '@cian/analytics';

import { IOfferForClientSchema } from '../../repositories/chats/entities/for_client/OfferForClientSchema';
import { TChatbotReaction, IChatbotMessageOfferSchema } from '../../types/chatbot';

type IBaseOfferSchema = IChatbotMessageOfferSchema & IOfferForClientSchema;

export const trackShowMessage = (
  chatId: string,
  messageId: string,
  communicationId?: string,
  attributes?: string,
  offer?: IBaseOfferSchema[],
) => {
  try {
    const products = Array.isArray(offer)
      ? offer.map((item, idx) => ({
          id: item.realtyOfferId,
          offerType: 'offer',
          position: item.position,
        }))
      : [];

    ca('eventSite', {
      name: 'oldevent',
      category: 'Chat',
      action: 'Show_sopr',
      label: 'Messages',
      page: {
        extra: {
          chat_id: chatId,
          messages_id: messageId,
          communication_id: communicationId,
          attributes,
        },
      },
      products,
    });
  } catch (error) {
    console.debug('trackShowMessage', error);
  }
};

export const trackClickMessage = ({
  chatId,
  messageId,
  messageType,
  offerId,
  communicationId,
  clickText,
}: {
  chatId: string;
  messageId: string;
  messageType: string;
  offerId?: number;
  communicationId?: string;
  clickText?: string;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'Messages',
    page: {
      extra: {
        chat_id: chatId,
        messages_id: messageId,
        communication_id: communicationId,
        message_type: messageType,
        click_text: clickText,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};

export const trackHiddenMessagePhoneClick = ({
  messageId,
  chatId,
  communicationId,
  offerId,
}: {
  messageId: string;
  chatId: string;
  communicationId?: string;
  offerId?: number;
}) => {
  const products = offerId ? [{ id: offerId, offerType: 'offer', position: 1 }] : [];

  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'ActionButton',
    products,
    page: {
      extra: {
        chat_id: chatId,
        messages_id: messageId,
        communication_id: communicationId,
        promoName: 'phone',
      },
    },
  });
};

export const trackLike = (
  offerId: number,
  reaction?: TChatbotReaction,
  communicationId?: string,
  position?: number,
) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: reaction === 'like' ? 'Click_sopr' : 'Remove_sopr',
    label: 'Good',
    page: {
      extra: {
        chat_id: 'chatbot',
        communication_id: communicationId,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
};
